import { ENV_CONFIG } from 'config/environment';
import LottieStory from 'components/LottieElements/Story';
import { Container, MotionText, StyledImage, Title } from './styled';
import { CURRENT_CYCLE_YEAR } from 'screens/Profile/utils';

export const Intro = ({ isPaused }) => {
  return (
    <LottieStory slide="blueOrbs" isPaused={isPaused}>
      <Container>
        <Title>{CURRENT_CYCLE_YEAR}</Title>
        <MotionText $size={24}>Impact Report</MotionText>
        <StyledImage
          alt="Oath logo"
          src={`${
            ENV_CONFIG().CLOUD_STORAGE.URL
          }/static_content/oath_logos/Oath_FullLockup_Color_LightText.svg`}
        />
      </Container>
    </LottieStory>
  );
};
